import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAsync } from '../hooks/useAsync';
import { useCloud } from '../context/CloudContext';
import PageHeader from '../components/PageHeader';
import Card from '../components/Card';
import { Loading, ErrorState, EmptyState } from '../components/States';
import { currency } from '../lib/format';

const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
};

export default function Contracts() {
  const navigate = useNavigate();
  const { providers } = useCloud();
  const { data, loading, error, reload } = useAsync(() => api.getContracts(), []);
  const providerShort = (id) => providers.find((p) => p.id === id)?.shortName || id;

  return (
    <div className="stack">
      <PageHeader
        title="Contract management"
        subtitle="Provider contracts and credit assignments"
        actions={
          <Link className="btn btn--primary" to="/contracts/new">
            + Create contract
          </Link>
        }
      />

      <Card title={`Contracts ${data ? `(${data.length})` : ''}`}>
        {loading ? (
          <Loading />
        ) : error ? (
          <ErrorState error={error} onRetry={reload} />
        ) : data.length === 0 ? (
          <EmptyState
            title="No contracts yet"
            detail="Create a contract to assign a provider and (optionally) a user group."
          />
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Type</th>
                  <th>Start</th>
                  <th>End</th>
                  <th className="num">Value</th>
                  <th>User group</th>
                </tr>
              </thead>
              <tbody>
                {data.map((c) => (
                  <tr
                    key={c.id}
                    onClick={() => navigate(`/contracts/${c.id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="cell-primary">{providerShort(c.providerId)}</td>
                    <td>
                      <span className="badge badge--info">{c.type}</span>
                    </td>
                    <td>{fmtDate(c.start)}</td>
                    <td>{fmtDate(c.end)}</td>
                    <td className="num">{currency(c.value, c.currency)}</td>
                    <td className="cell-type">{c.groupName || 'Unassigned'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
